import { useAuthProvider } from '../../AuthProvider';

export const useToken = () => {
  const authProvider = useAuthProvider();
  return authProvider.token;
};
